import React, { useEffect, useState, Fragment } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormControl,
  InputGroup,
  Modal,
  OverlayTrigger,
  Row,
  Toast,
  Tooltip
} from 'react-bootstrap'
import { CarpetaDigitalComponent } from 'reccol-caso-general'
import { useDispatch, useSelector } from 'react-redux'





const DatosTercero = ({formik,setIsModoContacto,setIsModoRespuesta,showToast,setShowToast}) => {
  const [showCarpeta, setShowCarpeta] = useState(false)
  const data_traza_modal = useSelector((state) => state.trazabilidadReducer)
  const {datosGestion} = data_traza_modal
   const data_modal_contacto = useSelector((state) => state.modalContactoTerceroReducer)
   const { cfg_form24,datosUltimoContacto,comboModoContactoModal,comboRespuestaContactoModal,respuestaContacto} = data_modal_contacto
   const data_recepciona = useSelector((state) => state.casoGeneralReducer)
   const { llaves} = data_recepciona
   const handleShowCarpeta = () => setShowCarpeta(true)
   const handleCloseCarpeta= () => setShowCarpeta(false)
  return (
    <>
 <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;

    }

    `}
    </style>
    <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">      
        
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
            prototipo={4}
            folder={'Gest-Contacto-Ter'}
            
          />     
     
    </Modal>

        <Card >
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form24
              ? cfg_form24.cfg_form24['consultactotercero-title-contactoter']
              : ''} {"- "}{datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['nombreImplicado'] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['nombreImplicado'] !== null &&
                datosUltimoContacto.datosUltimoContacto[0]['nombreImplicado'] !== ''
                ? datosUltimoContacto.datosUltimoContacto[0]['nombreImplicado']
                : ''}
          </Card.Header>
          <Container>
            <Container>

              {cfg_form24? (
                <div >

                  <Row >

                    <Col md="3">
                      <Form.Label
                        className='mb-2 mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form24.cfg_form24[
                            'consultactotercero-lbl-modocto'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['modoContacto'] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['modoContacto'] !== null &&
                datosUltimoContacto.datosUltimoContacto[0]['modoContacto'] !== ''
                ? datosUltimoContacto.datosUltimoContacto[0]['modoContacto']
                : ''}
                </Form.Text>
                    </Col>
                    <Col md="3">
                      <Form.Label
                        className='mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form24.cfg_form24[
                            'consultactotercero-lbl-fechacto'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['fechaContactoFormat'] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['fechaContactoFormat'] !== null &&
                datosUltimoContacto.datosUltimoContacto[0]['fechaContactoFormat'] !== ''
                ? datosUltimoContacto.datosUltimoContacto[0]['fechaContactoFormat']
                : ''}
                </Form.Text>

                    </Col>
                    <Col md="4">
                      <Form.Label
                        className='mt-4'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form24.cfg_form24[
                            'consultactotercero-lbl-comentariocto'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['comentarioContacto'] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['comentarioContacto'] !== null &&
                datosUltimoContacto.datosUltimoContacto[0]['comentarioContacto'] !== ''
                ? datosUltimoContacto.datosUltimoContacto[0]['comentarioContacto']
                : ''}
                </Form.Text>
                    </Col>
                  <Col>
                  <Button
                  className='mt-5'
                      type='button'
                      variant='outline-secondary me-md-2'
                      size='sm'
                       onClick={handleShowCarpeta}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                                </svg>
                    </Button>
                  </Col>


                  </Row>

                  <Row>
                    <Col md="3">
                      <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form24.cfg_form24[
                            'consultactotercero-lbl-respuestacto'
                          ]
                        }
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['modoRespuesta'] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['modoRespuesta'] !== null &&
                datosUltimoContacto.datosUltimoContacto[0]['modoRespuesta'] !== ''
                ? datosUltimoContacto.datosUltimoContacto[0]['modoRespuesta']
                : ''}
                </Form.Text>

                    </Col>
                    <Col md="3">
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form24.cfg_form24[
                            'consultactotercero-lbl-fecharesp'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['fechaRespuestaFormat'] !== undefined &&
                datosUltimoContacto.datosUltimoContacto[0]['fechaRespuestaFormat'] !== null &&
                datosUltimoContacto.datosUltimoContacto[0]['fechaRespuestaFormat'] !== ''
                ? datosUltimoContacto.datosUltimoContacto[0]['fechaRespuestaFormat']
                : ''}
                </Form.Text>
                    </Col>
                    <Col md="4">
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form24.cfg_form24[
                            'consultactotercero-lbl-comentarioresp'
                          ]
                        }
                      </Form.Label>
                      <br />
                      <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                        {datosUltimoContacto && datosUltimoContacto.datosUltimoContacto[0] !== undefined &&
                        datosUltimoContacto.datosUltimoContacto[0]['comentarioRespuesta'] !== undefined &&
                        datosUltimoContacto.datosUltimoContacto[0]['comentarioRespuesta'] !== null &&
                        datosUltimoContacto.datosUltimoContacto[0]['comentarioRespuesta'] !== ''
                        ? datosUltimoContacto.datosUltimoContacto[0]['comentarioRespuesta']
                        : ''}
                </Form.Text>
                    </Col>


                  </Row>

                  <hr style={{ color: '#04005D', height: '2px', marginTop:'30px' }}></hr>

                </div>
              ) : null}
            </Container>




          </Container>
        </Card>



    </>
  )
}

export default DatosTercero
